import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * Takes in a Title, onclick func, and size. Everything else as well, is
 * @param {*} props 
 * @returns 
 */
export function HHIEButton(props) {

    let style = {borderRadius: '10px', fontSize: '16px'};
    if (props.long) {
        style.minWidth = '100px';
    }
    if (props.noborder) {
        style.borderStyle = 'none';
    }
    if (props.marginl !== undefined || props.marginl !== null) {
        style.marginLeft = props.marginl + 'px'
    }
    if (props.margint !== undefined || props.margint !== null) {
        style.marginTop = props.margint + 'px'
    }
    
    return (
        <>
            <Button
                id={props.id}
                disabled={props.disabled}
                variant="primary"
                size={(props.size) ? props.size : "lg"}
                onClick={(props.onClick) ? props.onClick : () => {alert("Function not implemented yet, please pass in an onclick function.");}}
                style={style}
                {...props}
            >{(props.title) ? props.title : "Pass in title"}</Button>
        </>
    )
}
